import { Data as ArticleData } from '@root/modules/article/types/article';

export const doesArticleBaseDataExist = (article: ArticleData | null): boolean => {
  if (!article) {
    return false;
  }

  return Boolean(article.id && article.slug && article.content.title);
};
